<div class="page-container">
  <div class="title-box">
    <span class="title">{{ title }}</span>
  </div>

  <ng-content></ng-content>
</div>
